import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["src", "type", "displayName", "size", "source"];
import { Avatar } from 'trellis-components/components/Avatar';
import { unsafeReactNode } from 'trellis-components/utils/unsafeReactNode';
import { DEFAULT_AVATAR_TYPES } from '../Constants';
import { getDefaultAvatarType } from '../lib/getDefaultAvatarType';
import { displayNameToInitials } from '../lib/displayUtils';
import { AVATAR_SVG_DATA } from '../lib/avatarSvgData';
import { useHubSpotUserAvatarSrc } from '../lib/useHubSpotUserAvatarSrc';
import { jsx as _jsx } from "react/jsx-runtime";
const TRELLIS_SIZE_MAP = {
  xs: 'xs',
  sm: 'sm',
  md: 'md'
};
const AvatarTypeIcon = ({
  iconKey
}) => {
  const data = AVATAR_SVG_DATA[iconKey];
  const paths = 'paths' in data ? data.paths : data.trellis;
  return /*#__PURE__*/_jsx("svg", {
    viewBox: data.viewBox,
    focusable: "false",
    "data-svg-name": data.name,
    "data-test-id": "AvatarDisplay-svgIcon",
    style: {
      inlineSize: data.svgSize,
      blockSize: data.svgSize,
      fill: 'currentColor'
    },
    children: paths.map(d => /*#__PURE__*/_jsx("path", {
      d: d
    }, d))
  });
};
export const TrellisAvatarDisplay = _ref => {
  var _rest$dataTestId;
  let {
      src,
      type,
      displayName,
      size = 'sm',
      source
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    resolvedSrc
  } = useHubSpotUserAvatarSrc({
    src,
    source
  });
  const iconType = getDefaultAvatarType(type);
  const shape = iconType === DEFAULT_AVATAR_TYPES.PRODUCT ? 'square' : 'circle';
  const backgroundColor = iconType === DEFAULT_AVATAR_TYPES.AI_AGENT ? 'magenta' : 'neutral';
  let fallback = '';
  if (iconType === DEFAULT_AVATAR_TYPES.CONTACT) {
    const initials = displayNameToInitials({
      aString: displayName,
      displayName
    });
    fallback = initials !== null && initials !== void 0 ? initials : unsafeReactNode( /*#__PURE__*/_jsx(AvatarTypeIcon, {
      iconKey: "CONTACT"
    }));
  } else if (iconType) {
    fallback = unsafeReactNode( /*#__PURE__*/_jsx(AvatarTypeIcon, {
      iconKey: iconType
    }));
  }
  return /*#__PURE__*/_jsx(Avatar, {
    src: resolvedSrc,
    alt: displayName !== null && displayName !== void 0 ? displayName : '',
    fallback: fallback,
    size: TRELLIS_SIZE_MAP[size],
    shape: shape,
    backgroundColor: backgroundColor,
    ariaLabel: displayName ? {
      root: displayName
    } : undefined,
    dataTestId: {
      root: (_rest$dataTestId = rest['data-test-id']) !== null && _rest$dataTestId !== void 0 ? _rest$dataTestId : 'AvatarDisplay-avatarContent'
    }
  });
};
TrellisAvatarDisplay.displayName = 'TrellisAvatarDisplay';